import { useEffect, useState, useMemo, useCallback } from "react"
import assoc from "ramda/es/assoc"
import mergeLeft from "ramda/es/mergeLeft"
import { getList, getListCount } from "src/engine/repositories/role"

const initialState = {
  list: [],
  count: null,
  pending: false,
}

/**
 * Простейшей API для вывода списка ролей
 *
 * @param offset {number}
 * @param limit {number}
 * @param orderBy {string}
 * @param query {string}
 * @returns {object}
 */
export default ({ offset, limit, orderBy, query }) => {
  const [refreshed, setRefreshed] = useState(Date.now())
  const refresh = useCallback(() => {
    setRefreshed(Date.now())
  }, [])

  const [state, setState] = useState(initialState)

  useEffect(() => {
    setState(assoc(`pending`, true))
    Promise.all([
      getListCount({ query }),
      getList({ offset, limit, orderBy, query }),
    ])
      .then(([{ data: count }, { data: list }]) =>
        setState(
          mergeLeft({
            list,
            count,
            pending: false,
          }),
        ),
      )
      .catch(() => setState(initialState))
  }, [offset, limit, orderBy, query, refreshed])

  return useMemo(() => ({ state, refresh }), [state])
}
